import React, { useEffect, useState } from "react";
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content'
import * as myConstClass from '../../constantes.js';
import AuthUser from '../AuthUser';

const MySwal = withReactContent(Swal)

export default function EditarTipoPago() {
  const {http, catchError, jsonSaLoading, base} = AuthUser();
  const navigate = useNavigate();

  const { id } = useParams()

  const [description, setDescription] = useState("")
  const [serie, setSerie] = useState("")
  const [numero, setNumero] = useState("")
  const [validationError,setValidationError] = useState({})

  useEffect(()=>{
    fetchProduct()
  },[])

  const fetchProduct = async () => {
    MySwal.fire(jsonSaLoading(MySwal));
    await http.get(`/${base}/mantenedor/correlativo/${id}`).then(({data})=>{
      MySwal.close();
      const { descripcion, recibo_serie, recibo_numero } = data.correlativo ;
      let _serie = recibo_serie ? recibo_serie : 0 ;
      let _numero = recibo_numero ? recibo_numero : 0 ;
      setDescription(descripcion)
      setSerie(_serie)
      setNumero(_numero)
    }).catch(({response:{data}})=>{
      catchError(data);
    })
  }

  const updateProduct = async (e) => {
    e.preventDefault();

    const formData = new FormData()
    formData.append('_method', 'PATCH');
    formData.append('serie', serie)
    formData.append('numero', numero)

    MySwal.fire(jsonSaLoading(MySwal, "Modificando registro"));
    await http.post(`/${base}/mantenedor/correlativo/${id}`, formData).then(({data})=>{
      Swal.fire({
        icon:"success",
        text:data.message,
        allowOutsideClick: false,
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Ok'
      })
      navigate("/correlativo_trabajador")
    }).catch(({response})=>{
      if(response.status===422){
          setValidationError(response.data.errors)
      }else{        
          catchError(response);
      }
    })
  }

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-12 col-sm-12 col-md-6">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Actualizar correlativo</h4>
              <h6>{description}</h6>
              <hr />
              <div className="form-wrapper">
                {
                  Object.keys(validationError).length > 0 && (
                    <div className="row">
                      <div className="col-12">
                        <div className="alert alert-danger">
                          <ul className="mb-0">
                            {
                              Object.entries(validationError).map(([key, value])=>(
                                <li key={key}>{value}</li>   
                              ))
                            }
                          </ul>
                        </div>
                      </div>
                    </div>
                  )
                }
                <Form onSubmit={updateProduct}>           
                    <Row className="my-3">         
                      <Col>
                          <Form.Group controlId="Serie">
                              <Form.Label>Serie</Form.Label>
                              <Form.Control type="text" value={serie} onChange={(event)=>{
                                  setSerie(event.target.value)
                              }}/>
                          </Form.Group>
                      </Col>
                      <Col>
                          <Form.Group controlId="Numero">
                              <Form.Label>Número</Form.Label>
                              <Form.Control type="text" value={numero} onChange={(event)=>{
                                  setNumero(event.target.value)
                              }}/>
                          </Form.Group>
                      </Col>
                    </Row>
                    <Button variant="primary" className="mt-2 btn-sm" size="lg" block="block" type="submit">
                        Actualizar
                    </Button>
                    <Link className='btn btn-outline-primary btn-sm mt-2 float-end' to={"/correlativo_trabajador/"}>
                        Ver todos
                    </Link>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
